import { render, staticRenderFns } from "./showimg.vue?vue&type=template&id=74ea424c&"
import script from "./showimg.vue?vue&type=script&lang=js&"
export * from "./showimg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports